import React from 'react';
import { Identifier } from 'react-admin';
import { useMetadataBatch } from '../../../hooks/useMetadataBatch';

interface Props {
    name: string;
    metadataAvatarType: Identifier;
}

const MetadataAvatarTypePropertiesBatched: React.FC<Props> = ({ 
    name, 
    metadataAvatarType 
}) => {
    console.log('🔄 MetadataAvatarTypePropertiesBatched called for:', name, metadataAvatarType);
    const property = useMetadataBatch(metadataAvatarType, name);
    
    if (!property) {
        return <>N/A</>;
    }
    
    const value = property.values && Array.isArray(property.values) && property.values.length === 1
        ? property.values[0]
        : '';
    const unit = property.unit ? property.unit : '';
    const result = `${value} ${unit}`.trim();
    
    return <>{result || 'N/A'}</>;
};

export default MetadataAvatarTypePropertiesBatched;
